import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import "moment/locale/es";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import FeatherIcon from "feather-icons-react";
import { saveBotonMensaje } from "../../accion/accion";
import { buscarCantidadChatSinLeer, listarSedes } from "../../API/Core";
import styled from "styled-components";

//componentes
import "./cita.css";
import Chat from "../Chat/index";
import Alert from "../../modal/alert";
import ConsultarInfTe2 from "../consultarInfTe2";
import PerfilEspecialista from "../perfilEspecialista/PerfilEspecialista";
import logo1 from "../../imagenes/Logo.jpg";
// import Recibo from "../recepcion/recepcion";
class CitasAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idseccion: "",
      cedulaAlumno: "",
      idseccionA: "",
      trimestre: "",
      idmateria: "",
      anoEscolar: [moment().format("YYYY")],
      ianoEscolar: [],
      iseccionesA: [],
      iinasistencia: [],
      ialumnos: [],
      isecciones: [],
      imaterias: [],
      listaOn: false,
      elimi: false,
      verplanillaOn: false,
      xtotales: "",
      iinformeFechasS: [],
      iinformeFechas: [],
      identificacionp1: "",
      tbusqueda: "",
      cedula: "",
      iterapeuta: [],
      terapeuta: "",

      lunesI: 1,
      martesI: 2,
      miercolesI: 3,
      juevesI: 4,
      viernesI: 5,
      sabadoI: 6,
      domingoI: 7,
      fechaSeleccionada: new Date(),
      fechaInicio: new Date(),
      icasos: [],
      imedicos: [],
      casos: "",
      casos2: "",
      medicos: "",
      tipoFecha: "2",
      fechaIni: "",
      fechaFin: "",
      fechaDescansoI: "",
      fechaDescansoF: "",
      verHorarioOn: false,
      consultandoHorario: false,
      ihorario: [],
      dia1: "",
      dia2: "",
      dia3: "",
      dia4: "",
      dia5: "",
      dia6: "",
      diaI: "",
      diaF: "",
      incluirdatosOn: false,
      alumno: "",
      horaS: "",
      fechaT: moment().format("YYYY-MM-DD"),
      confirmadoOn: false,
      ayudaOn: false,
      enconsultaOn: false,
      dolarOn: false,
      canceladoOn: false,
      noasistioOn: false,
      esperaOn: false,
      nocobradoOn: false,
      donacionOn: false,
      estatusOn: false,
      numeroEstatus: "",
      idasociar: "",
      fechaActual2: moment().format("YYYY-MM-DD"),
      fechaActual: "",
      fechadeldia: moment().format("YYYY-MM-DD"),
      tipoEstudio: "",
      tipoEva: "",
      iultimaCita: [],
      idiasDis: [],
      diasDis: "",
      nota: "",
      notaOn: false,
      cambioOn: false,
      horaC1: "",
      diaCalendario: "",
      fechaNuevaCita: "",
      cambioEstudioOn: false,
      cambioAnuladoOn: false,
      facturaNoAsitioOn: false,
      bandera: "",
      correrF: "",
      habilitarReciOn: false,
      recibosE: "",
      irecibosE: [],
      sede: "",
      tipoEstu: "",
      estatusAnterior: "",
      facturasAtrasadas: "",
      ifacturasAtrasadas: [],
      facturasAtrasadasOn: false,
      autorizado: "",
      fechaDiaConsulta: moment().format("YYYY-MM-DD"),
      diaConsulta: "",
      estatusEspecialista: "",
      cedulaPaciente: "",
      sala: "",
      cedulaEspe: "",
      nombreEspe: "",
      nombrePaciente: "",
      idespecialista: "",
      ilistaSalas: [],
      listaSalaOn: false,
      listaReporteOn: false,
      informesOn: false,
      perfilOn: false,
      idsala: "",
      reporte: "",
      tidasociarE: "",
      tfechadia: "",
      fechaDesde: "",
      fechaHasta: "",
      isedes: [],
    };
  }

  limpiar = () => {
    this.setState({
      idseccionP: "",
      elimi: false,
      listaOn: false,
      iinformeFechasS: [],
      iinformeFechas: [],
      identificacionp1: "",
      tbusqueda: "",
      cedula: "",
      terapeuta: "",
      lunesI: 1,
      martesI: 2,
      miercolesI: 3,
      juevesI: 4,
      viernesI: 5,
      sabadoI: 6,
      domingoI: 7,
      fechaSeleccionada: new Date(),
      fechaInicio: new Date(),
      casos: "",
      casos2: "",
      medicos: "",
      tipoFecha: "1",
      fechaIni: "",
      fechaFin: "",
      fechaDescansoI: "",
      fechaDescansoF: "",
      verHorarioOn: false,
      consultandoHorario: false,
      ihorario: [],
      dia1: "",
      dia2: "",
      dia3: "",
      dia4: "",
      dia5: "",
      dia6: "",
      diaI: "",
      diaF: "",
      incluirdatosOn: false,
      alumno: "",
      horaS: "",
      fechaT: moment().format("YYYY-MM-DD"),
      confirmadoOn: false,
      ayudaOn: false,
      enconsultaOn: false,
      dolarOn: false,
      canceladoOn: false,
      noasistioOn: false,
      esperaOn: false,
      nocobradoOn: false,
      donacionOn: false,
      estatusOn: false,
      numeroEstatus: "",
      idasociar: "",
      fechaActual: "",
      tipoEstudio: "",
      tipoEva: "",
      iultimaCita: [],
      idiasDis: [],
      diasDis: "",
      nota: "",
      notaOn: false,
      cambioOn: false,
      horaC1: "",
      diaCalendario: "",
      fechaNuevaCita: "",
      cambioEstudioOn: false,
      cambioAnuladoOn: false,
      facturaNoAsitioOn: false,
      bandera: "",
      correrF: "",
      habilitarReciOn: false,
      recibosE: "",
      irecibosE: [],
      sede: "",
      tipoEstu: "",
      estatusAnterior: "",
      facturasAtrasadas: "",
      ifacturasAtrasadas: [],
      facturasAtrasadasOn: false,
      autorizado: "",
      fechaDiaConsulta: moment().format("YYYY-MM-DD"),
      diaConsulta: "",
      estatusEspecialista: "",
      cedulaPaciente: "",
      sala: "",
      cedulaEspe: "",
      nombreEspe: "",
      nombrePaciente: "",
      idespecialista: "",
      ilistaSalas: [],
      listaSalaOn: false,
      listaReporteOn: false,
      informesOn: false,
      perfilOn: false,
      idsala: "",
      reporte: "",
      tidasociarE: "",
      tfechadia: "",
      fechaDesde: "",
      fechaHasta: "",
    });
  };
  onChange(e) {
    //console.log(e.target.name);
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (e.target.name === "casos") {
      //this.terapeutasDisponibles(e.target.value);
    }
    if (e.target.name === "medicos") {
      // this.consultarHorarioEspecialista(e.target.value);
    }
    if (e.target.name === "sede") {
      this.setState({
        casos: "",
        imedicos: [],
        verHorarioOn: false,
        ihorario: [],
      });
    }

    if (e.target.name === "tipoFecha") {
      if (e.target.value === "2") {
        this.state.tipoFecha = "2";
        this.valorInicial(e.target.value);
        this.consultarHorarioEspecialista(this.state.medicos);
      }
      if (e.target.value === "1") {
        this.state.tipoFecha = "1";
        this.valorInicial("1");
        this.consultarHorarioEspecialista(this.state.medicos);
      }
    }

    // if (e.target.name === "numeroEstatus") {
    if (e.target.getAttribute("data-name") === "numeroEstatus") {
      if (
        e.target.value !== "4" &&
        e.target.value !== "5" &&
        e.target.value !== "6" &&
        e.target.value !== "10" &&
        e.target.value !== "11" &&
        e.target.value !== "14" &&
        e.target.value !== "15" &&
        e.target.value !== "16" &&
        e.target.value !== "17" &&
        e.target.value !== "18"
      ) {
        this.setState({
          estatusOn: false,
        });

        this.actualizarEstatus(e.target.value);
      }

      if (e.target.value === "17" || e.target.value === "18") {
        //console.log(e.target.getAttribute("id"));
        // console.log(e.target.getAttribute("id"));
        // let index = (e.target.getAttribute("id"));
        // console.log(index);
        // console.log( e.target.getAttribute("data-fechaActual"));
        // console.log(e.target.name);

        this.actualizarEstatus2(
          e.target.value,
          e.target.getAttribute("id"),
          e.target.getAttribute("data-fechaActual")
        );
      }

      if (e.target.value === "4") {
        if (this.state.facturasAtrasadas === "0") {
          this.setState({
            estatusOn: false,
            habilitarReciOn: true,
          });
        } else {
          this.setState({
            estatusOn: false,
            facturasAtrasadasOn: true,
          });
        }
      }
      if (e.target.value === "5") {
        this.setState({
          nota: "",
          cambioAnuladoOn: true,
        });
      }
      if (e.target.value === "6" || e.target.value === "10") {
        this.setState({
          nota: "",
          notaOn: true,
        });
      }
      if (e.target.value === "11") {
        this.setState({
          nota: "",
          cambioOn: true,
        });
      }
      if (e.target.value === "15") {
        this.setState({
          nota: "",
          facturaNoAsitioOn: true,
        });
      }
      if (e.target.value === "16") {
        this.setState({
          nota: "",
          facturaNoAsitioOn: true,
        });
      }
      if (e.target.value === "14") {
        this.setState({
          nota: "",
          cambioEstudioOn: true,
        });
      }
    }
  }

  onChange2(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
    this.buscarAlumnos(e.target.value);
    //this.buscarSeccionesA(e.target.value);
  }

  onChange3(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
    //this.buscarAlumnos(e.target.value);
  }
  onChange4(e) {
    // console.log(this.state.nana)
    // console.log(e.target.checked)
    if (e.target.checked) {
      this.setState({
        correrF: "SI",
      });
    } else {
      this.setState({
        correrF: "",
      });
    }
  }
  onChange5 = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });

    let data = new FormData();
    data.append("numeroRecibo", e.target.value);
    data.append("tipoFact", "SERVICIOS");
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reciboPago4.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  habilitarRecibo = () => {
    if (this.state.habilitarReciOn) {
      this.consultarHorarioEspecialista(this.state.medicos);
      this.setState({
        habilitarReciOn: false,
      });
    }
    if (!this.state.habilitarReciOn) {
      this.setState({
        habilitarReciOn: true,
      });
    }
  };

  facturaNoAsitio = () => {
    if (this.state.facturaNoAsitioOn) {
      this.setState({
        estatusOn: false,
        facturaNoAsitioOn: false,
        bandera: "",
      });
    }
    if (!this.state.facturaNoAsitioOn) {
      this.setState({
        facturaNoAsitioOn: true,
      });
    }
  };

  facturasAt = () => {
    if (this.state.facturasAtrasadasOn) {
      this.setState({
        facturasAtrasadasOn: false,
      });
    }
    if (!this.state.facturasAtrasadasOn) {
      this.setState({
        facturasAtrasadasOn: true,
      });
    }
  };

  consutarNotas = () => {
    if (this.state.notaOn) {
      this.setState({
        estatusOn: false,
        notaOn: false,
        bandera: "",
      });
    }
    if (!this.state.notaOn) {
      this.setState({
        notaOn: true,
      });
    }
  };

  consutarCambios = () => {
    if (this.state.cambioOn) {
      this.setState({
        estatusOn: false,
        cambioOn: false,
        bandera: "",
      });
    }
    if (!this.state.cambioOn) {
      this.setState({
        cambioOn: true,
      });
    }
  };

  cambiarEstu = () => {
    if (this.state.cambioEstudioOn) {
      this.setState({
        estatusOn: false,
        cambioEstudioOn: false,
        bandera: "",
      });
    }
    if (!this.state.cambioEstudioOn) {
      this.setState({
        cambioEstudioOn: true,
      });
    }
  };
  cambiarAnu = () => {
    if (this.state.cambioAnuladoOn) {
      this.setState({
        estatusOn: false,
        cambioAnuladoOn: false,
        bandera: "",
      });
    }
    if (!this.state.cambioAnuladoOn) {
      this.setState({
        cambioAnuladoOn: true,
      });
    }
  };

  guardarEstatusAnu = () => {
    this.setState({
      notaOn: false,
      estatusOn: false,
      cambioAnuladoOn: false,
      bandera: "",
    });
    this.actualizarEstatus(this.state.numeroEstatus);
  };

  guardarNotas = () => {
    this.setState({
      notaOn: false,
      estatusOn: false,
      bandera: "",
    });
    this.actualizarEstatus(this.state.numeroEstatus);
  };

  guardarFacturaNoAsitio2 = () => {
    //console.log(this.state.tipoFecha);
    // console.log(moment(this.state.fechaT).format("YYYY-MM-DD"))
    // console.log(this.state.casos2)
    // console.log(this.state.medicos)
    // console.log(moment(this.state.fechaT).day())
    // console.log(this.state.horaS+':00')
    if (this.state.correrF !== "SI" && this.state.nota.length > 0) {
      this.setState({
        fechaNuevaCita: "",
        horaC1: "",
      });
      let data = new FormData();
      data.append("cedulaP", this.state.cedulaAlumno);
      if (this.state.tipoFecha === "2")
        data.append(
          "fechaP",
          moment(this.state.fechaActual).format("YYYY-MM-DD")
        );
      if (this.state.tipoFecha === "1")
        data.append("fechaP", moment(this.state.diaI).format("YYYY-MM-DD"));
      data.append("tipoEvaluacionP", this.state.casos2);
      data.append("especialistaP", this.state.medicos);
      data.append("fechaE1", "");
      data.append("fechaE2", "");
      data.append("fechaE3", "");
      data.append("fechaE4", "");
      data.append("tipoEstudio", this.state.tipoEstudio);
      data.append("nuevaHora", this.state.horaC1);
      data.append("nuevaFecha", this.state.fechaNuevaCita);
      data.append("nota", this.state.nota);
      data.append("idasociarE", this.state.idasociar);
      data.append("numeroEstatus", this.state.numeroEstatus);
      data.append("boton", "guardarFacturaNoAsitio");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/asociarEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              estatusOn: false,
              facturaNoAsitioOn: false,
              bandera: "",
              // mensajealerta: true,
              // tituloM: "Menu Agendar Citas.",
              // cuerpoM: "La Cita se Guardo con Exito",
            });
            this.consultarHorarioEspecialista(this.state.medicos);
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Cambio de Citas.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Agendar Citas.",
        cuerpoM: "Debe seleccionar un tipo de Consulta",
      });
    }
  };

  guardarFacturaNoAsitio = () => {
    //console.log(this.state.tipoFecha);
    // console.log(moment(this.state.fechaT).format("YYYY-MM-DD"))
    // console.log(this.state.casos2)
    // console.log(this.state.medicos)
    // console.log(moment(this.state.fechaT).day())
    // console.log(this.state.horaS+':00')
    if (
      this.state.correrF === "SI" &&
      this.state.nota.length > 0 &&
      this.state.fechaNuevaCita.length > 0 &&
      this.state.horaC1.length > 0
    ) {
      let data = new FormData();
      data.append("cedulaP", this.state.cedulaAlumno);
      if (this.state.tipoFecha === "2")
        data.append(
          "fechaP",
          moment(this.state.fechaActual).format("YYYY-MM-DD")
        );
      if (this.state.tipoFecha === "1")
        data.append("fechaP", moment(this.state.diaI).format("YYYY-MM-DD"));
      data.append("tipoEvaluacionP", this.state.casos2);
      data.append("especialistaP", this.state.medicos);
      data.append("fechaE1", "");
      data.append("fechaE2", "");
      data.append("fechaE3", "");
      data.append("fechaE4", "");
      data.append("tipoEstudio", this.state.tipoEstudio);
      data.append("nuevaHora", this.state.horaC1);
      data.append("nuevaFecha", this.state.fechaNuevaCita);
      data.append("nota", this.state.nota);
      data.append("idasociarE", this.state.idasociar);
      data.append("numeroEstatus", this.state.numeroEstatus);
      data.append("boton", "guardarFacturaNoAsitio");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/asociarEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              estatusOn: false,
              facturaNoAsitioOn: false,
              bandera: "",
              // mensajealerta: true,
              // tituloM: "Menu Agendar Citas.",
              // cuerpoM: "La Cita se Guardo con Exito",
            });
            this.consultarHorarioEspecialista(this.state.medicos);
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Cambio de Citas.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Agendar Citas.",
        cuerpoM: "Debe seleccionar un tipo de Consulta",
      });
    }
  };

  terapeutasDisponibles = (e) => {
    let data = new FormData();
    data.append("idespecialidad", e);
    data.append("nivel", this.props.usuario1.nivel);
    if (this.state.sede.length === 0)
      data.append("sede", this.props.usuario1.sede);
    if (this.state.sede.length > 0) data.append("sede", this.state.sede);
    data.append("boton", "consultaTerapeutasEspecialista");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let ximedicos = res.data.variable2;
        let xidiasDis = res.data.variable3;
        if (res.data.variable1) {
          this.setState({
            medicos: "",
            imedicos: [],
            idiasDis: [],
            imedicos: ximedicos,
            idiasDis: xidiasDis,
          });
        } else {
          this.setState({
            medicos: "",
            imedicos: [],
          });
        }
      });
  };

  consultar(e) {
    if (parseFloat(e) > 0) {
      axios
        .post(
          "https://fehensa.com/consultorio/ingresaresperaPHP.php/?codigo=" +
            e +
            "&cedula=&motivo=&fecha=&boton=Consultar"
        )
        //console.log('https://fehensa.com/consultorio/ingresaresperaPHP.php/?codigo='+e+'&cedula=&motivo=&fecha=&boton=Consultar')
        .then((res) => {
          if (res.data) {
            this.setState({
              //   codigo: res.data.variable1,
              //   cedula: res.data.variable2,
              //   nombre: res.data.variable3,
              //   motivo: res.data.variable4,
              //   ordendellegada: res.data.variable5,
            });
          }
        });
    }
  }

  imprimir = () => {
    let data = new FormData();
    data.append("cedulaTerapeuta", this.state.terapeuta);
    data.append("arregloPaciente", JSON.stringify(this.state.iinformeFechasS));
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteHorarioEspecialista.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  buscarI = () => {
    if (
      this.state.trimestre.length > 0 &&
      // this.state.idmateria.length > 0 &&
      this.state.idseccion.length > 0
    ) {
      let data = new FormData();
      data.append("idseccion", this.state.idseccion);
      data.append("cedulaAlumno", this.state.cedulaAlumno);
      data.append("trimestre", this.state.trimestre);
      data.append("idmateria", this.state.idmateria);
      data.append("anoEscolar", this.state.anoEscolar);
      if (this.state.cedulaAlumno === "") {
        data.append("boton", "buscarInasistenciaG");
      } else {
        data.append("boton", "buscarInasistencia");
      }

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/alumnoMaestro.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            let xiinasis = res.data.variable2;
            this.setState({
              iinasistencia: xiinasis,
              xtotales: res.data.variable3,
            });
          } else {
            let xiinasis = res.data.variable2;
            this.setState({
              iinasistencia: xiinasis,
              mensajealerta: true,
              tituloM: "Menu Consultar Inasistencias.",
              cuerpoM: res.data.variable3,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Consultar Inasistencias.",
        cuerpoM:
          "Debe seleccionar un Trimestre, un Alumno, un Grado y una Materia.",
      });
    }
  };

  eliminar = () => {
    if (this.state.idseccionA.length > 0) {
      let data = new FormData();
      data.append("idseccionesA", this.state.idseccionA);
      data.append("boton", "eliminarSeccionesA");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/seccionesA.php";
      axios.post(xurl, data, config).then((res) => {
        if (res.data.variable1) {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Asignar Grados Alumnos.",
            cuerpoM: res.data.variable2,
          });
          this.buscarSeccionesA(this.state.cedulaAlumno);
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Asignar Grados Alumnos.",
            cuerpoM: res.data.variable2,
          });
        }
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Grados Alumnos.",
        cuerpoM: "Debe existir un registro para poder eliminar la Sección.",
      });
    }
  };

  buscarSeccionesA = (e) => {
    if (this.state.anoEscolar.length > 0) {
      if (e.length > 0) {
        let data = new FormData();
        data.append("anoEscolar", this.state.anoEscolar);
        data.append("cedulaAlumno", e);
        data.append("boton", "buscarSeccionesA");

        let config = {
          headers: {
            "Content-Type": "text/html",
          },
        };
        const xurl =
          "https://institutobilinguelasnaciones.com/terapias/backend/seccionesA.php";
        axios
          .post(xurl, data, config)

          .then((res) => {
            let xisecciones = res.data.variable3;
            let xiseccionesA = res.data.variable2;
            if (res.data.variable1) {
              this.setState({
                isecciones: xisecciones,
                iseccionesA: xiseccionesA,
              });
            } else {
              this.setState({
                iseccionesP: [],
              });
            }
          });
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Menu Asignar Grados Alumnos.",
          cuerpoM: "Debe existir un Alumno para realizar el proceso.",
        });
      }
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Seccion Alumnos.",
        cuerpoM: "Debe seleccionar un Año Escolar.",
      });
    }
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  buscarAlumnos = (e) => {
    let form = new FormData();
    form.append("anoEscolar", this.state.anoEscolar);
    form.append("idcurso", e);
    form.append("boton", "buscarAlumnosG");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/seccionesA.php";
    axios.post(xurl, form, config).then((res) => {
      let xialumnos = res.data.variable2;
      this.setState({
        ialumnos: xialumnos,
      });
    });
  };

  buscarAnioEscolar = () => {
    let data = new FormData();
    data.append("boton", "buscarAnioEscolar");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/maternal.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          //anoEscolar: res.data.variable2,
          ianoEscolar: res.data.variable3,
        });
      }
    });
  };

  eliminar1 = (e) => {
    this.setState({
      mensajealerta: true,
      tituloM: "Menu Asignar Grados a Alumnos",
      cuerpoM:
        "Puede que el Grado Asignado ya tenga notas Asociadas, Desea Realmente Eliminar el Registro...",
      idseccionA: e,
      elimi: true,
    });
  };

  handleEliminar = () => {
    this.setState({
      mensajealerta: false,
      elimi: false,
    });
    this.eliminar();
    //console.log('eliminar')
  };

  buscarIT = () => {
    let data = new FormData();
    //data.append("cedulaTerapeuta", this.state.terapeuta);
    data.append("cedulaTerapeuta", this.state.medicos);
    data.append("boton", "consultarInformeTerapeuta");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xiinformeFechasS = res.data.variable2;
        let xiinformeFechas = res.data.variable3;
        if (res.data.variable1) {
          this.setState({
            iinformeFechasS: [],
            iinformeFechas: [],
            iinformeFechasS: xiinformeFechasS,
            iinformeFechas: xiinformeFechas,
          });
        } else {
          this.setState({
            iinformeFechasS: [],
            iinformeFechas: [],
          });
        }
      });
  };

  buscarPlanillaIndividual = () => {
    if (this.state.identificacionp1.length > 0) {
      let data = new FormData();
      data.append("cedulaAlumno", this.state.identificacionp1);
      data.append("desde", "citas");
      if (this.state.sede.length === 0)
        data.append("sede", this.props.usuario1.sede);
      if (this.state.sede.length > 0) data.append("sede", this.state.sede);
      data.append("boton", "buscarPlanillaIndividual");
      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/maternal.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          //console.log(res.data.variable133)
          if (res.data.variable136) {
            if (res.data.variable129 === "MADRE") {
              this.setState({
                alumno: res.data.variable1 + " " + res.data.variable2,
                cedula: res.data.variable4,
                cedulaAlumno: res.data.variable4,
                listaOn: false,
                verplanillaOn: false,
                incluirdatosOn: true,
              });
              this.buscarIT(res.data.variable4);
              // this.buscarCXC(res.data.variable4);
              // this.buscarNC();
            } else {
              this.setState({
                alumno: res.data.variable1 + " " + res.data.variable2,
                cedula: res.data.variable4,
                cedulaAlumno: res.data.variable4,
                listaOn: false,
                verplanillaOn: false,
                incluirdatosOn: true,
              });
              this.buscarIT(res.data.variable4);
              // this.buscarCXC(res.data.variable4);
              // this.buscarNC();
            }
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Busqueda de Planillas",
              cuerpoM: "La cédula que intenta consultar no existe, gracias...",
            });
          }
        });
    }
  };

  buscarPorNombres = () => {
    let data = new FormData();
    data.append("nombres", this.state.identificacionp1);
    data.append("desde", "citas");
    if (this.state.sede.length === 0)
      data.append("sede", this.props.usuario1.sede);
    if (this.state.sede.length > 0) data.append("sede", this.state.sede);
    data.append("boton", "buscarNombres");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/maternal.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        //console.log(res.data.variable3);
        //console.log(res.data.variable2);
        if (res.data.variable1) {
          let xnalumno = res.data.variable2;
          this.setState({
            nalumno: xnalumno,
            listaOn: true,
          });
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Busqueda de Planillas",
            cuerpoM:
              "No existe ningún Paciente con ese Nombre en esta Sede, gracias...",
          });
        }
      });
  };

  consulta = (e) => {
    if (e.length > 0) {
      let data = new FormData();
      data.append("idAlumno", e);
      data.append("boton", "buscarPlanillaIndividual1");
      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/maternal.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          console.log(res.data.variable133);
          if (res.data.variable136) {
            if (res.data.variable129 === "MADRE") {
              this.setState({
                alumno: res.data.variable1 + " " + res.data.variable2,
                cedula: res.data.variable4,
                cedulaAlumno: res.data.variable4,
                listaOn: false,
                verplanillaOn: false,
                incluirdatosOn: true,
              });
              this.buscarIT(res.data.variable4);
              // this.buscarCXC(res.data.variable4);
              // this.buscarNC();
            } else {
              this.setState({
                alumno: res.data.variable1 + " " + res.data.variable2,
                cedula: res.data.variable4,
                cedulaAlumno: res.data.variable4,
                listaOn: false,
                verplanillaOn: false,
                incluirdatosOn: true,
              });
              this.buscarIT(res.data.variable4);
              // this.buscarCXC(res.data.variable4);
              // this.buscarNC();
            }
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Busqueda de Planillas",
              cuerpoM: "La cédula que intenta consultar no existe, gracias...",
            });
          }
        });
    }
  };

  cargarSalaCreada = () => {
    //console.log(e)
    //console.log(f);
    if (this.state.listaOn) {
      this.setState({
        listaOn: false,
      });
    }
    if (!this.state.listaOn) {
      let data = new FormData();
      data.append("idsala", this.state.idsala);
      data.append("boton", "consultaSalaCreada");
      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/chat.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              listaOn: true,
              listaSalaOn: false,
              cedulaPaciente: res.data.variable2,
              sala: res.data.variable3,
              cedulaEspe: res.data.variable4,
              nombreEspe: res.data.variable5,
              nombrePaciente: res.data.variable6,
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Cambio de Citas.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    }
  };

  cerrarLista = (e) => {
    console.log(e);
    //console.log(f);
    if (this.state.listaOn) {
      this.setState({
        listaOn: false,
      });
    }
    if (!this.state.listaOn) {
      let data = new FormData();
      data.append("idasociarE", e);
      data.append("boton", "consultaCedulaPaciente");
      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/asociarEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              listaOn: true,
              cedulaPaciente: res.data.variable2,
              sala: res.data.variable3,
              cedulaEspe: res.data.variable4,
              nombreEspe: res.data.variable5,
              nombrePaciente: res.data.variable6,
              reporte: "",
              tidasociarE: "",
              tfechadia: "",
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Cambio de Citas.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    }
  };

  cerrarLista2 = (e, f) => {
    // console.log(e);
    // console.log(f);
    if (this.state.listaOn) {
      this.setState({
        listaOn: false,
      });
    }
    if (!this.state.listaOn) {
      let data = new FormData();
      data.append("idasociarE", e);
      data.append("boton", "consultaCedulaPaciente");
      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/asociarEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              listaOn: true,
              cedulaPaciente: res.data.variable2,
              sala: res.data.variable3,
              cedulaEspe: res.data.variable4,
              nombreEspe: res.data.variable5,
              nombrePaciente: res.data.variable6,
              tidasociarE: e,
              tfechadia: moment(f).format("YYYY-MM-DD"),
              reporte: "1",
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Cambio de Citas.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    }
  };
  incluirdatos = () => {
    //console.log(this.state.listaOn)
    if (this.state.incluirdatosOn) {
      this.setState({
        incluirdatosOn: false,
      });
    }
    if (!this.state.incluirdatosOn) {
      this.setState({
        incluirdatosOn: true,
      });
    }
  };

  buscarPlanilla = () => {
    if (
      this.state.tbusqueda === "1" ||
      this.state.tbusqueda === "2" ||
      this.state.tbusqueda === "3" ||
      this.state.tbusqueda === "4"
    ) {
      if (this.state.tbusqueda === "1") {
        this.buscarPlanillaIndividual();
      }
      if (this.state.tbusqueda === "2") {
        this.buscarPorNombres();
      }
      if (this.state.tbusqueda === "3") {
        this.setState({ grado: "0" });
        this.buscarCursosGrados();
        //this.buscarCursosGrados()
      }
      if (this.state.tbusqueda === "4") {
        this.buscarPorNombres3();
      }
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Busqueda de Planillas",
        cuerpoM:
          "Debe seleccionar un Año escolar y un tipo de busqueda, gracias...",
      });
    }
  };

  buscarE = () => {
    let data = new FormData();
    data.append("cedula", this.props.usuario1.cedulaU);
    data.append("boton", "Consultar");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/medicos.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        //console.log(res.data.variable3);
        console.log(res.data.variable6);
        if (res.data.variable6 !== "") {
          this.initData2(res.data.variable6);
        }

        this.setState({
          idespecialista: res.data.variable6,
        });
      });
  };

  onClickPrevNextLabel = ({ activeStartDate, value, view }) => {
    // console.log("vv:", activeStartDate, value, view);
    // console.log(value);
    this.setState({
      fechaSeleccionada: activeStartDate,
    });
  };

  onClickMonth = (e) => {
    this.setState({
      fechaSeleccionada: e,
    });

    // console.log(e);
    // console.log('mes');
  };
  valorInicial = (e) => {
    if (e === "2") {
      let xfecha = new Date(moment(this.state.fechaSeleccionada).format());

      let xdia1 = new Date(
        moment(xfecha, "DD-MM-YYYY").add(-(xfecha.getDay() - 1), "day")
      );
      let xdia2 = new Date(moment(xdia1, "DD-MM-YYYY").add(1, "day"));
      let xdia3 = new Date(moment(xdia2, "DD-MM-YYYY").add(1, "day"));
      let xdia4 = new Date(moment(xdia3, "DD-MM-YYYY").add(1, "day"));
      let xdia5 = new Date(moment(xdia4, "DD-MM-YYYY").add(1, "day"));
      let xdia6 = new Date(moment(xdia5, "DD-MM-YYYY").add(1, "day"));
      this.state.diaI = xdia1;
      this.state.diaF = xdia6;
      // this.state.diaConsulta = moment(this.state.fechaDiaConsulta).day();
      this.setState({
        dia1: xdia1.getDate(),
        dia2: xdia2.getDate(),
        dia3: xdia3.getDate(),
        dia4: xdia4.getDate(),
        dia5: xdia5.getDate(),
        dia6: xdia6.getDate(),
        fechaSeleccionada: xdia1,
        sede: this.props.usuario1.sede,
        diaConsulta: moment(this.state.fechaDiaConsulta).day(),
        medicos: this.props.usuario1.cedulaU,
        //medicos: "E-8-139687",
        //medicos: "8-915-218",
      });
    }

    if (e === "1") {
      let xfecha = new Date(moment(this.state.fechaSeleccionada).format());
      //      let xfecha = new Date(e);
      let xdia1 = new Date(moment(xfecha, "DD-MM-YYYY"));
      this.state.diaI = xdia1;
      this.setState({
        diaF: "",
        dia1: xdia1.getDate(),
        dia2: "",
        dia3: "",
        dia4: "",
        dia5: "",
        dia6: "",
        fechaSeleccionada: xdia1,
        sede: this.props.usuario1.sede,
      });
    }
  };

  derecha = () => {
    if (this.state.tipoFecha === "2") {
      let xfecha = new Date(
        moment(this.state.fechaSeleccionada).add(7, "day").format()
      );

      let xdia1 = new Date(
        moment(xfecha, "DD-MM-YYYY").add(-(xfecha.getDay() - 1), "day")
      );
      let xdia2 = new Date(moment(xdia1, "DD-MM-YYYY").add(1, "day"));
      let xdia3 = new Date(moment(xdia2, "DD-MM-YYYY").add(1, "day"));
      let xdia4 = new Date(moment(xdia3, "DD-MM-YYYY").add(1, "day"));
      let xdia5 = new Date(moment(xdia4, "DD-MM-YYYY").add(1, "day"));
      let xdia6 = new Date(moment(xdia5, "DD-MM-YYYY").add(1, "day"));
      this.state.diaI = xdia1;
      this.state.diaF = xdia6;
      this.setState({
        dia1: xdia1.getDate(),
        dia2: xdia2.getDate(),
        dia3: xdia3.getDate(),
        dia4: xdia4.getDate(),
        dia5: xdia5.getDate(),
        dia6: xdia6.getDate(),
        fechaSeleccionada: xdia1,
      });
      this.consultarHorarioEspecialista(this.state.medicos);
    }
    if (this.state.tipoFecha === "1") {
      let xfecha = new Date(
        moment(this.state.fechaSeleccionada).add(1, "day").format()
      );

      let xdia1 = new Date(moment(xfecha, "DD-MM-YYYY"));
      this.state.diaI = xdia1;
      this.setState({
        diaF: "",
        dia1: xdia1.getDate(),
        dia2: "",
        dia3: "",
        dia4: "",
        dia5: "",
        dia6: "",
        fechaSeleccionada: xdia1,
      });
      this.consultarHorarioEspecialista(this.state.medicos);
    }
  };
  izquierda = () => {
    // console.log(this.state.fechaSeleccionada);
    // console.log(this.state.fechaSeleccionada.getMonth());
    // console.log(this.state.fechaSeleccionada.getDay());
    // console.log(this.state.fechaSeleccionada.getDate());
    // let xfecha = new Date(
    //   moment(this.state.fechaSeleccionada).add(-7, "day").format()
    // );
    // console.log(xfecha);
    // console.log(xfecha.getMonth());
    // console.log(xfecha.getDay());
    // console.log(xfecha.getDate());
    //console.log(this.state.tipoFecha);
    if (this.state.tipoFecha === "2") {
      let xfecha = new Date(
        moment(this.state.fechaSeleccionada).add(-7, "day").format()
      );

      let xdia1 = new Date(
        moment(xfecha, "DD-MM-YYYY").add(-(xfecha.getDay() - 1), "day")
      );
      let xdia2 = new Date(moment(xdia1, "DD-MM-YYYY").add(1, "day"));
      let xdia3 = new Date(moment(xdia2, "DD-MM-YYYY").add(1, "day"));
      let xdia4 = new Date(moment(xdia3, "DD-MM-YYYY").add(1, "day"));
      let xdia5 = new Date(moment(xdia4, "DD-MM-YYYY").add(1, "day"));
      let xdia6 = new Date(moment(xdia5, "DD-MM-YYYY").add(1, "day"));
      this.state.diaI = xdia1;
      this.state.diaF = xdia6;
      this.setState({
        dia1: xdia1.getDate(),
        dia2: xdia2.getDate(),
        dia3: xdia3.getDate(),
        dia4: xdia4.getDate(),
        dia5: xdia5.getDate(),
        dia6: xdia6.getDate(),
        fechaSeleccionada: xdia1,
      });
      this.consultarHorarioEspecialista(this.state.medicos);
    }
    if (this.state.tipoFecha === "1") {
      let xfecha = new Date(
        moment(this.state.fechaSeleccionada).add(-1, "day").format()
      );

      let xdia1 = new Date(moment(xfecha, "DD-MM-YYYY"));
      this.state.diaI = xdia1;
      this.setState({
        diaF: "",
        dia1: xdia1.getDate(),
        dia2: "",
        dia3: "",
        dia4: "",
        dia5: "",
        dia6: "",
        fechaSeleccionada: xdia1,
      });
      this.consultarHorarioEspecialista(this.state.medicos);
    }
  };
  onClickDay1 = () => {
    // console.log(e);
    // console.log(e.getMonth());
    // console.log(e.getDay());
    // console.log(e.getDate());
    if (this.state.tipoFecha === "2") {
      let e = new Date(moment(this.state.fechaDiaConsulta, "YYYY-MM-DD"));
      let xfecha = new Date(moment(e, "YYYY-MM-DD").add(-1, "day"));

      this.state.fechaDiaConsulta = moment(xfecha).format("YYYY-MM-DD");
      this.state.diaConsulta = moment(this.state.fechaDiaConsulta).day();
      let diaSemana = moment(this.state.fechaDiaConsulta).day();
      let diaIni = diaSemana - 1;

      let xdia1 = new Date(
        moment(this.state.fechaDiaConsulta, "YYYY-MM-DD").add(-diaIni, "day")
      );
      // let xdia1 = new Date(
      //   moment(xfecha, "YYYY-MM-DD").subtract(-(e.getDay()), "day")
      // );

      // let xxdia1 = new Date(e.getDay());

      let xdia2 = new Date(moment(xdia1, "YYYY-MM-DD").add(1, "day"));
      let xdia3 = new Date(moment(xdia2, "YYYY-MM-DD").add(1, "day"));
      let xdia4 = new Date(moment(xdia3, "YYYY-MM-DD").add(1, "day"));
      let xdia5 = new Date(moment(xdia4, "YYYY-MM-DD").add(1, "day"));
      let xdia6 = new Date(moment(xdia5, "YYYY-MM-DD").add(1, "day"));
      this.setState({
        diaI: xdia1,
        diaF: xdia6,
        dia1: xdia1.getDate(),
        dia2: xdia2.getDate(),
        dia3: xdia3.getDate(),
        dia4: xdia4.getDate(),
        dia5: xdia5.getDate(),
        dia6: xdia6.getDate(),
        fechaSeleccionada: xdia1,
      });
      console.log("fecha1: " + this.state.fechaDiaConsulta);
      console.log("fecha2: " + this.state.diaConsulta);
      console.log("fecha3: " + diaSemana);
      console.log("fecha3: " + diaIni);
      console.log("fecha3: " + xdia1);
      this.consultarHorarioEspecialista(this.state.medicos, xdia1, xdia6);
    }
  };

  onClickDay2 = () => {
    // console.log(e);
    // console.log(e.getMonth());
    // console.log(e.getDay());
    // console.log(e.getDate());

    if (this.state.tipoFecha === "2") {
      let e = new Date(moment(this.state.fechaDiaConsulta, "YYYY-MM-DD"));
      let xfecha = new Date(moment(e, "YYYY-MM-DD").add(1, "day"));

      this.state.fechaDiaConsulta = moment(xfecha).format("YYYY-MM-DD");
      this.state.diaConsulta = moment(this.state.fechaDiaConsulta).day();

      let xdia1 = new Date(
        moment(xfecha, "YYYY-MM-DD").add(-e.getDay(), "day")
      );
      let xdia2 = new Date(moment(xdia1, "YYYY-MM-DD").add(1, "day"));
      let xdia3 = new Date(moment(xdia2, "YYYY-MM-DD").add(1, "day"));
      let xdia4 = new Date(moment(xdia3, "YYYY-MM-DD").add(1, "day"));
      let xdia5 = new Date(moment(xdia4, "YYYY-MM-DD").add(1, "day"));
      let xdia6 = new Date(moment(xdia5, "YYYY-MM-DD").add(1, "day"));
      this.setState({
        diaI: xdia1,
        diaF: xdia6,
        dia1: xdia1.getDate(),
        dia2: xdia2.getDate(),
        dia3: xdia3.getDate(),
        dia4: xdia4.getDate(),
        dia5: xdia5.getDate(),
        dia6: xdia6.getDate(),
        fechaSeleccionada: xdia1,
      });
      console.log("fecha1: " + this.state.fechaDiaConsulta);
      console.log("fecha2: " + this.state.diaConsulta);
      console.log("fecha3: " + xdia1);
      this.consultarHorarioEspecialista(this.state.medicos, xdia1, xdia6);
    }
  };

  asociarEvaluacion = () => {
    let data = new FormData();
    data.append("boton", "Consultar");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/maestroCasosPHP.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xcasos = res.data;
        this.setState({
          icasos: xcasos,
        });
      });
  };

  consultarHorarioEspecialista = (e, f, g) => {
    let data = new FormData();
    data.append("cedulaEspecialista", e);
    data.append("nivel", this.props.usuario1.nivel);
    if (this.state.sede.length === 0)
      data.append("sede", this.props.usuario1.sede);
    if (this.state.sede.length > 0) data.append("sede", this.state.sede);
    data.append("dia", this.state.diaI.getDay());
    data.append("tipoEva", this.state.casos);
    if (this.state.tipoFecha === "2") {
      if (f !== undefined) {
        data.append("fechadia", moment(f).format("YYYY-MM-DD"));
      }
      if (g !== undefined) {
        data.append("fechafin", moment(g).format("YYYY-MM-DD"));
      }
      if (f === undefined) {
        data.append("fechadia", moment(this.state.diaI).format("YYYY-MM-DD"));
      }
      if (g === undefined) {
        data.append("fechafin", moment(this.state.diaF).format("YYYY-MM-DD"));
      }
    }
    if (this.state.tipoFecha === "1") {
      data.append("fechadia", moment(this.state.diaI).format("YYYY-MM-DD"));
    }

    data.append("tbusqueda", this.state.tipoFecha);
    data.append("boton", "consultarHorarioEspecialista2");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    this.setState({ consultandoHorario: true });
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data && res.data.variable1) {
          this.setState({
            verHorarioOn: true,
            ihorario: res.data.variable2 || [],
          });
        } else {
          this.setState({
            verHorarioOn: false,
            ihorario: (res.data && res.data.variable2) || [],
          });
        }
      })
      .catch(() => {})
      .then(() => {
        this.setState({ consultandoHorario: false });
      });
  };

  incluirEstatus = () => {
    //console.log(this.state.listaOn)
    if (this.state.estatusOn) {
      this.setState({
        estatusOn: false,
        bandera: "",
        alumno: "",
        numeroEstatus: "",
        idasociar: "",
      });
    }
    if (!this.state.estatusOn) {
      this.setState({
        estatusOn: true,
      });
    }
  };

  verNota = () => {
    let data = new FormData();
    if (this.state.tipoFecha === "1")
      data.append("fechadia", moment(this.state.diaI).format("YYYY-MM-DD"));
    if (this.state.tipoFecha === "2")
      data.append(
        "fechadia",
        moment(this.state.fechaActual).format("YYYY-MM-DD")
      );
    data.append("idasociarE", this.state.idasociar);
    data.append("estatus", this.state.numeroEstatus);

    data.append("boton", "verNotas");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          // this.consultarHorarioEspecialista(this.state.medicos);
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Consultar Observación.",
            cuerpoM: res.data.variable2,
          });
        }
      });
  };

  actualizarEstatus = (e) => {
    let data = new FormData();
    if (this.state.tipoFecha === "1")
      data.append("fechadia", moment(this.state.diaI).format("YYYY-MM-DD"));
    if (this.state.tipoFecha === "2")
      data.append(
        "fechadia",
        moment(this.state.fechaActual).format("YYYY-MM-DD")
      );
    data.append("idasociarE", this.state.idasociar);
    data.append("estatus", e);
    data.append("nota", this.state.nota);

    data.append("boton", "actualizarEstatusEspecialista");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          this.consultarHorarioEspecialista(this.state.medicos);
          this.setState({
            // alumno: f,
            // numeroEstatus: res.data.variable2,
            // idasociar:h,
          });
        }
      });
  };

  actualizarEstatus2 = (e, f, g) => {
    let data = new FormData();

    data.append("fechadia", g);
    data.append("idasociarE", f);
    data.append("estatus", e);
    data.append("nota", this.state.nota);

    data.append("boton", "actualizarEstatusEspecialista");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          this.consultarHorarioEspecialista(this.state.medicos);
          this.setState({
            // alumno: f,
            // numeroEstatus: res.data.variable2,
            // idasociar:h,
          });
        }
      });
  };

  consultarPaciente = (e, f, g, h, j, k) => {
    console.log("datos " + j + " - " + k);

    if (j !== "0" && j !== "5" && j !== "11") {
      //if (j !== "0" && j !== "5" && j !== "11") {
      //console.log("tiene datos " + h);
      this.state.bandera = "1";
      //this.setState({bandera:'1',});
      let data = new FormData();
      data.append("idasociarE", h);
      if (this.state.tipoFecha === "2") {
        data.append("fechadia", moment(k).format("YYYY-MM-DD"));
      }
      if (this.state.tipoFecha === "1") {
        data.append("fechadia", moment(this.state.diaI).format("YYYY-MM-DD"));
      }
      data.append("sede", this.state.sede);
      data.append("boton", "consultarstatus");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            // if (this.state.facturasAtrasadas === "0") {
            let xiultimaCita = res.data.variable5;

            if (this.state.tipoFecha === "1") {
              this.setState({
                fechaActual: moment(this.state.diaI).format("YYYY-MM-DD"),
              });
            }
            if (this.state.tipoFecha === "2") {
              this.setState({
                fechaActual: k,
              });
            }
            if (res.data.variable10 === 1) {
              this.state.fechadeldia = this.state.fechaActual;
            }
            this.setState({
              estatusOn: true,
              alumno: f,
              numeroEstatus: res.data.variable2,
              idasociar: h,
              cedulaAlumno: res.data.variable3,
              tipoEva: res.data.variable4,
              iultimaCita: xiultimaCita,
              irecibosE: res.data.variable6,
              tipoEstu: res.data.variable7,
              facturasAtrasadas: res.data.variable8,
              ifacturasAtrasadas: res.data.variable9,
              estatusAnterior: j,
              autorizado: res.data.variable10,
              estatusEspecialista: res.data.variable11,
            });
            if (res.data.variable11 === "17" || res.data.variable11 === "18") {
              this.setState({
                numeroEstatus: res.data.variable11,
              });
            }
          } else {
            this.setState({
              estatusOn: false,
              tipoEva: "",
              bandera: "",
              irecibosE: [],
            });
          }
        });
    }
  };

  consultarPaciente2 = (e, f, g, h, j, k) => {
    console.log("datos2 " + j + " - " + k);
    console.log("bandera: " + this.state.bandera);
    if (j === "0" && this.state.bandera === "") {
      let xfechaT = "";
      let xdia = "";
      if (g >= xdia) {
        xdia = moment(this.state.diaI).format("DD");
        xfechaT = new Date(
          moment(this.state.diaI, "DD-MM-YYYY").add(g - xdia, "day")
        );
      }
      if (g < xdia) {
        xdia = moment(this.state.diaF).format("DD");
        xfechaT = new Date(
          moment(this.state.diaF, "DD-MM-YYYY").add(-(xdia - g), "day")
        );
      }

      this.setState({
        horaS: e.substring(0, 2),
        fechaT: moment(xfechaT).format("YYYY-MM-DD"),
        casos2: this.state.casos,
        verplanillaOn: true,
      });
    }
  };

  guardarCita = () => {
    // console.log(this.state.cedulaAlumno)
    // console.log(moment(this.state.fechaT).format("YYYY-MM-DD"))
    // console.log(this.state.casos2)
    // console.log(this.state.medicos)
    // console.log(moment(this.state.fechaT).day())
    // console.log(this.state.horaS+':00')
    if (this.state.tipoEstudio.length > 0) {
      let data = new FormData();
      data.append("cedulaP", this.state.cedulaAlumno);
      if (this.state.tipoFecha === "2")
        data.append("fechaP", moment(this.state.fechaT).format("YYYY-MM-DD"));
      if (this.state.tipoFecha === "1")
        data.append("fechaP", moment(this.state.diaI).format("YYYY-MM-DD"));
      data.append("tipoEvaluacionP", this.state.casos2);
      data.append("especialistaP", this.state.medicos);
      data.append("fechaE1", "");
      data.append("fechaE2", "");
      data.append("fechaE3", "");
      data.append("fechaE4", "");
      data.append("tipoEstudio", this.state.tipoEstudio);
      data.append("hora", this.state.horaS + ":00");
      data.append("nivel", this.props.usuario1.nivel);
      if (this.state.sede.length === 0)
        data.append("sede", this.props.usuario1.sede);
      if (this.state.sede.length > 0) data.append("sede", this.state.sede);
      data.append("boton", "guardarAsociarE");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/asociarEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              // mensajealerta: true,
              // tituloM: "Menu Agendar Citas.",
              // cuerpoM: "La Cita se Guardo con Exito",
            });
            this.guardarCalendario(res.data.variable2);
            this.incluirdatos();
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Agendar Citas.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Agendar Citas.",
        cuerpoM: "Debe seleccionar un tipo de Consulta",
      });
    }
  };

  guardarCambio = () => {
    //console.log(this.state.tipoFecha);
    // console.log(moment(this.state.fechaT).format("YYYY-MM-DD"))
    // console.log(this.state.casos2)
    // console.log(this.state.medicos)
    // console.log(moment(this.state.fechaT).day())
    // console.log(this.state.horaS+':00')
    if (
      this.state.nota.length > 0 &&
      this.state.fechaNuevaCita.length > 0 &&
      this.state.horaC1.length > 0
    ) {
      let data = new FormData();
      data.append("cedulaP", this.state.cedulaAlumno);
      if (this.state.tipoFecha === "2")
        data.append(
          "fechaP",
          moment(this.state.fechaActual).format("YYYY-MM-DD")
        );
      if (this.state.tipoFecha === "1")
        data.append("fechaP", moment(this.state.diaI).format("YYYY-MM-DD"));
      data.append("tipoEvaluacionP", this.state.casos2);
      data.append("especialistaP", this.state.medicos);
      data.append("fechaE1", "");
      data.append("fechaE2", "");
      data.append("fechaE3", "");
      data.append("fechaE4", "");
      data.append("tipoEstudio", this.state.tipoEstudio);
      data.append("nuevaHora", this.state.horaC1);
      data.append("nuevaFecha", this.state.fechaNuevaCita);
      data.append("nota", this.state.nota);
      data.append("idasociarE", this.state.idasociar);
      data.append("boton", "cambioHorario");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/asociarEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              estatusOn: false,
              cambioOn: false,
              bandera: "",
              // mensajealerta: true,
              // tituloM: "Menu Agendar Citas.",
              // cuerpoM: "La Cita se Guardo con Exito",
            });
            this.consultarHorarioEspecialista(this.state.medicos);
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Cambio de Citas.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Agendar Citas.",
        cuerpoM: "Debe seleccionar un tipo de Consulta",
      });
    }
  };

  guardarTipoEstudio = () => {
    if (this.state.tipoEstudio.length > 0) {
      let data = new FormData();
      data.append("tipoEstudio", this.state.tipoEstudio);
      data.append("idasociarE", this.state.idasociar);
      data.append("boton", "actualizarEstudio");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              estatusOn: false,
              cambioEstudioOn: false,
              bandera: "",
            });
            this.consultarHorarioEspecialista(this.state.medicos);
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Cambio de Estudio.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Cambio de Estudio.",
        cuerpoM: "Debe seleccionar un tipo de Estudio",
      });
    }
  };

  guardarCalendario = (e) => {
    let data = new FormData();

    data.append("iditen", e);
    if (this.state.tipoFecha === "2") {
      data.append("dia", moment(this.state.fechaT).day());
      data.append("fecha", moment(this.state.fechaT).format("YYYY-MM-DD"));
    }
    if (this.state.tipoFecha === "1") {
      data.append("dia", moment(this.state.diaI).day());
      data.append("fecha", moment(this.state.diaI).format("YYYY-MM-DD"));
    }

    data.append("hora", this.state.horaS + ":00");
    data.append("boton", "guardarCalendario");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/asociarEvaluacion.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          mensajealerta: true,
          tituloM: "Menu Agendar Citas.",
          cuerpoM: "La Cita se Guardo con Exito",
          incluirdatosOn: false,
        });
        // this.consultarCalendario(e);
        this.consultarHorarioEspecialista(this.state.medicos);
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Menu Agendar Citas.",
          cuerpoM: res.data.variable2,
        });
      }
    });
  };

  historia = () => {};
  consultaHorario = () => {
    this.consultarHorarioEspecialista(this.state.medicos);
  };

  noCumplioEstatus = () => {
    this.setState({
      mensajealerta: true,
      tituloM: "Menu Atender Pacientes.",
      cuerpoM:
        "El Paciente No Puede Ser Atendido Ya Que Falta Realizar El Pago.",
    });
  };
  listaSala = () => {
    if (this.state.listaSalaOn) {
      this.setState({
        listaSalaOn: false,
      });
    }
    if (!this.state.listaSalaOn) {
      this.setState({
        listaSalaOn: true,
      });
    }
  };

  listaReporte = () => {
    if (this.state.listaReporteOn) {
      this.setState({
        listaReporteOn: false,
      });
    }
    if (!this.state.listaReporteOn) {
      this.setState({
        listaReporteOn: true,
      });
    }
  };

  listaInformes = () => {
    if (this.state.informesOn) {
      this.setState({
        informesOn: false,
      });
    }
    if (!this.state.informesOn) {
      this.setState({
        informesOn: true,
        perfilOn: false,
      });
    }
  };

  abrirPerfil = () => {
    if (this.state.perfilOn) {
      this.setState({ perfilOn: false });
      return;
    }
    this.setState({
      perfilOn: true,
      informesOn: false,
      listaReporteOn: false,
    });
  };
  crearInf = () => {};

  initData2 = async (e) => {
    let response = await buscarCantidadChatSinLeer(e);
    if (response.data.variable1) {
      this.props.saveBotonMensaje(true);
      this.setState({
        ilistaSalas: response.data.variable3,
      });
    } else {
      this.props.saveBotonMensaje(false);
      this.setState({
        ilistaSalas: [],
      });
    }
  };

  componentDidMount() {
    this.buscarE();
    this.asociarEvaluacion();
    this.valorInicial(this.state.tipoFecha);

    listarSedes()
      .then((res) => {
        if (res.data && res.data.variable1 && res.data.variable2) {
          this.setState({
            isedes: res.data.variable2,
          });
        }
      })
      .catch(() => {});

    this.intervalo = setInterval(() => {
      this.initData2(this.state.idespecialista);
    }, 10000);

    // console.log(this.props.usuario1.sede)
    // console.log("fecha: " +this.state.fechaDiaConsulta);
    // console.log("dia: "+ moment(this.state.fechaDiaConsulta).day());
  }

  listadoReporteNoCreados = () => {
    //this.setState({ loading: true });
    let data = new FormData();
    data.append("desde", this.state.fechaDesde);
    data.append("hasta", this.state.fechaHasta);
    data.append("sede", this.state.sede);
    data.append("especialista", this.props.usuario1.cedulaU);

    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteEspecialistaNoCreadosInd.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
      //this.limpiar2()
    });
  };

  componentWillUnmount() {
    clearInterval(this.intervalo);
  }

  render() {
    const has_message = this.props.botonMen.botonMensaje;

    return (
      <div className="principal-pago row">
        <div className="contenedor-cxcP col-12">
          <div className="titulo-cxc ">
            <p>MAESTRO DE CITAS. </p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
              eliminar={this.state.elimi}
              handleEliminar={this.handleEliminar}
            />
          )}

          {this.state.listaOn && (
            <div className="cont-tablamensaje row">
              <div className="tablamensaje col-12">
                <Chat
                  tituloMensaje={this.state.tituloM}
                  cuerpoMensaje={this.state.cuerpoM}
                  open={this.state.mensajealerta}
                  cerrarLista={this.cerrarLista}
                  cedulaP={this.state.cedulaPaciente}
                  nombrePaciente={this.state.nombrePaciente}
                  salaP={this.state.sala}
                  cedulaEsp={this.state.cedulaEspe}
                  nombreEsp={this.state.nombreEspe}
                  reporte={this.state.reporte}
                  idasociar={this.state.tidasociarE}
                  fechadia={this.state.tfechadia}
                />
              </div>
            </div>
          )}

          {this.state.listaSalaOn === true && (
            <div className="flotador3xM">
              <div className="flotador1">
                <div className="titulo-cxcC ">
                  <p>LISTA DE MENSAJES POR VISUALIZAR. </p>
                </div>
                <div className="fechas col-12">
                  <select
                    id="idsala"
                    name="idsala"
                    value={this.state.idsala}
                    onChange={this.onChange.bind(this)}
                  >
                    <option>-- Pacientes --</option>
                    {this.state.ilistaSalas.map((item, i) => {
                      return (
                        <option key={item.variable1} value={item.variable1}>
                          {item.variable2}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="fechasL col-12">
                  <button
                    className="boton"
                    onClick={this.cargarSalaCreada.bind()}
                  >
                    VISUALIZAR
                  </button>
                  <button className="boton" onClick={this.listaSala.bind()}>
                    SALIR
                  </button>
                </div>
              </div>
            </div>
          )}

          {this.state.listaReporteOn === true && (
            <div className="flotador3xM">
              <div className="flotador1">
                <div className="titulo-cxcC ">
                  <p>LISTA DE REPORTES NO CREADOS. </p>
                </div>
                <div className="contenedorcedula1f col-12">
                  <select
                    id="sede"
                    name="sede"
                    value={this.state.sede}
                    onChange={this.onChange.bind(this)}
                  >
                    <option>-Sucursal-</option>
                    {this.state.isedes.map((item, i) => {
                      return (
                        <option key={i} value={item.variable1}>
                          {item.variable2}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="contenedorcedula1f col-6">
                  <label>
                    Desde
                    <input
                      className="form-control"
                      type="date"
                      name="fechaDesde"
                      id="fechaDesde"
                      autoComplete="off"
                      onChange={this.onChange.bind(this)}
                      value={this.state.fechaDesde}
                    />
                  </label>
                </div>

                <div className="contenedorcedula1f col-6">
                  <label>
                    Hasta
                    <input
                      className="form-control"
                      type="date"
                      name="fechaHasta"
                      id="fechaHasta"
                      autoComplete="off"
                      onChange={this.onChange.bind(this)}
                      value={this.state.fechaHasta}
                    />
                  </label>
                </div>
                <div className="fechasL col-12">
                  <button
                    className="boton"
                    onClick={this.listadoReporteNoCreados.bind()}
                  >
                    VISUALIZAR
                  </button>
                  <button className="boton" onClick={this.listaReporte.bind()}>
                    SALIR
                  </button>
                </div>
              </div>
            </div>
          )}

          {this.state.informesOn === true && (
            <div className="flotadorInformes">
              <div className="flotadorInformesHeader">
                <button className="boton" onClick={this.listaInformes.bind(this)}>
                  Cerrar
                </button>
              </div>
              <div className="flotadorInformesBody">
                <ConsultarInfTe2 onClose={this.listaInformes} />
              </div>
            </div>
          )}

          {this.state.perfilOn === true && (
            <div className="flotadorInformes">
              <div className="flotadorInformesHeader">
                <button className="boton" onClick={this.abrirPerfil}>
                  Cerrar
                </button>
              </div>
              <div className="flotadorInformesBody">
                <PerfilEspecialista
                  cedula={this.props.usuario1.cedulaU}
                  nombre={this.props.usuario1.usuario}
                />
              </div>
            </div>
          )}

          <div className="col-12">
            <div className="row">
              <div className="form-group col-12">
                <div className="fechas col-12">
                  {/* {this.props.usuario1.nivel === "1" && ( */}
                  <select
                    id="sede"
                    name="sede"
                    value={this.state.sede}
                    onChange={this.onChange.bind(this)}
                  >
                    <option>-Seleccione Sucursal-</option>
                    {this.state.isedes.map((item, i) => {
                      return (
                        <option key={i} value={item.variable1}>
                          {item.variable2}
                        </option>
                      );
                    })}
                  </select>
                  {/* )} */}
                  {/* {this.state.sede.length > 0 && (
                    <select
                      id="casos"
                      name="casos"
                      value={this.state.casos}
                      onChange={this.onChange.bind(this)}
                    >
                      <option>-Seleccione Especialidad-</option>
                      {this.state.icasos.map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable2}
                          </option>
                        );
                      })}
                    </select>
                  )} */}
                  {/* </div> */}

                  {/* <div className="xcontenedorcedula1 col-12"> */}

                  <button
                    className="boton"
                    disabled={this.state.consultandoHorario}
                    onClick={this.consultaHorario.bind(this)}
                  >
                    {this.state.consultandoHorario
                      ? "Cargando horario…"
                      : "Consultar Horario"}
                  </button>
                  <button
                    className="boton"
                    onClick={this.listaReporte.bind(this)}
                  >
                    Reporte No Creados
                  </button>
                  <button
                    className="boton"
                    onClick={this.listaInformes.bind(this)}
                  >
                    Informes
                  </button>
                  <button className="boton" onClick={this.abrirPerfil}>
                    Mi perfil
                  </button>

                  <Link to="/">
                    <button className="boton">Salir</button>
                  </Link>
                  {/* </div> */}
                </div>
              </div>

              {this.state.ihorario.length > 0 && (
                <div class="contenedor-citas row col-12">
                  <div className="cont-Boton col-2">
                    <div className="btn-group" role="group">
                      <button
                        className="botonff1"
                        onClick={this.onClickDay1.bind(this)}
                      >
                        {"<"}
                      </button>
                      <button
                        className="botonff2"
                        onClick={this.onClickDay2.bind(this)}
                      >
                        {">"}
                      </button>
                    </div>
                  </div>
                  <div className="usu-cabeceraC col-8">
                    {has_message === true && (
                      <LinkContainer>
                        <Link>
                          <Boton onClick={this.listaSala.bind()}>
                            <BadgeNotification />
                            <FeatherIcon icon="list" size="10" stroke="#888" />
                          </Boton>
                        </Link>
                      </LinkContainer>
                    )}
                    {has_message !== true && (
                      <LinkContainer>
                        <Link>
                          {/* <BadgeNotification /> */}
                          <FeatherIcon icon="list" size="10" stroke="#888" />
                        </Link>
                      </LinkContainer>
                    )}
                  </div>

                  {/* <div class="col-12 align-self-start">
                    {this.state.tipoFecha === "2" && (
                      <p className="mostrarFechas">
                        {moment(this.state.diaI).format("DD-MM-YYYY")}
                        {" - "}
                        {moment(this.state.diaF).format("DD-MM-YYYY")}
                      </p>
                    )}
                    {this.state.tipoFecha === "1" && (
                      <p className="mostrarFechas">
                        {moment(this.state.diaI).format("DD-MM-YYYY")}
                      </p>
                    )}
                  </div> */}
                  {this.state.tipoFecha === "2" && (
                    <div className="padre row cabeceraHorarioAjuste">
                      <div className="diasH">HORA</div>
                      {this.state.diaConsulta === 1 && (
                        <div className="diasS">LUNES {this.state.dia1}</div>
                      )}
                      {this.state.diaConsulta === 2 && (
                        <div className="diasS">MARTES {this.state.dia2}</div>
                      )}
                      {this.state.diaConsulta === 3 && (
                        <div className="diasS">MIERCOLES {this.state.dia3}</div>
                      )}
                      {this.state.diaConsulta === 4 && (
                        <div className="diasS">JUEVES {this.state.dia4}</div>
                      )}
                      {this.state.diaConsulta === 5 && (
                        <div className="diasS">VIERNES {this.state.dia5}</div>
                      )}
                      {this.state.diaConsulta === 6 && (
                        <div className="diasS">SABADO {this.state.dia6}</div>
                      )}
                    </div>
                  )}

                  {this.state.tipoFecha === "2" && (
                    <div
                      id="detalleseleccion"
                      name="detalleseleccion"
                      className="este"
                    >
                      {this.state.ihorario.map((item, i) => {
                        return (
                          <div className="cont-diasterapia">
                            {/* {i === 0 && (
                              <div className="padre row">
                                <div className="diasH">HORA</div>
                                {this.state.diaConsulta === 1 && (
                                  <div className="diasS">
                                    LUNES {this.state.dia1}
                                  </div>
                                )}
                                {this.state.diaConsulta === 2 && (
                                  <div className="diasS">
                                    MARTES {this.state.dia2}
                                  </div>
                                )}
                                {this.state.diaConsulta === 3 && (
                                  <div className="diasS">
                                    MIERCOLES {this.state.dia3}
                                  </div>
                                )}
                                {this.state.diaConsulta === 4 && (
                                  <div className="diasS">
                                    JUEVES {this.state.dia4}
                                  </div>
                                )}
                                {this.state.diaConsulta === 5 && (
                                  <div className="diasS">
                                    VIERNES {this.state.dia5}
                                  </div>
                                )}
                                {this.state.diaConsulta === 6 && (
                                  <div className="diasS">
                                    SABADO {this.state.dia6}
                                  </div>
                                )}
                              </div>
                            )} */}
                            {item.variable2 === "NO LABORA" && (
                              <div className="padre row">
                                <div className="XdiasHl">{item.variable1}</div>

                                {this.state.diaConsulta === 1 && (
                                  <div className="XdiasSl">
                                    {item.variable2}
                                  </div>
                                )}
                                {this.state.diaConsulta === 2 && (
                                  <div className="XdiasSl">
                                    {item.variable3}
                                  </div>
                                )}
                                {this.state.diaConsulta === 3 && (
                                  <div className="XdiasSl">
                                    {item.variable4}
                                  </div>
                                )}
                                {this.state.diaConsulta === 4 && (
                                  <div className="XdiasSl">
                                    {item.variable5}
                                  </div>
                                )}
                                {this.state.diaConsulta === 5 && (
                                  <div className="XdiasSl">
                                    {item.variable6}
                                  </div>
                                )}
                                {this.state.diaConsulta === 6 && (
                                  <div className="XdiasSl">
                                    {item.variable7}
                                  </div>
                                )}
                              </div>
                            )}
                            {item.variable2 !== "NO LABORA" && (
                              <div className="padre row">
                                <div className="XdiasH">{item.variable1}</div>

                                {this.state.diaConsulta === 1 && (
                                  <div
                                    className="XdiasSDC2"
                                    onClick={
                                      item.variable8 === "4"
                                        ? this.consultarPaciente2.bind(
                                            this,
                                            item.variable1,
                                            item.variable2,
                                            this.state.dia1,
                                            item.variable14,
                                            "0",
                                            item.variable20
                                          )
                                        : item.variable8 !== "0"
                                        ? this.noCumplioEstatus.bind(this)
                                        : ""
                                    }
                                  >
                                    {item.variable8 !== "0" && (
                                      <div
                                        className="counter2"
                                        onClick={
                                          item.variable8 === "4"
                                            ? this.consultarPaciente.bind(
                                                this,
                                                item.variable1,
                                                item.variable2,
                                                this.state.dia1,
                                                item.variable14,
                                                item.variable8,
                                                item.variable20
                                              )
                                            : ""
                                        }
                                      >
                                        <div
                                          className={
                                            item.variable8 !== "4"
                                              ? "dato1"
                                              : "datox1"
                                          }
                                        >
                                          <div className="counter">
                                            {item.variable2 !== "" ? (
                                              <span className="iconosE">
                                                {item.variable26 !== "15" &&
                                                  item.variable26 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable26
                                                      }
                                                      icon={item.variable26}
                                                    />
                                                  )}
                                                {item.variable26 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable26 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable26 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable26 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable74 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable74 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable62}
                                                  icon={item.variable62}
                                                />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {item.variable2}
                                        </div>
                                        {item.variable32 !== "" ? (
                                          <div
                                            className={
                                              item.variable32 !== ""
                                                ? "dato2"
                                                : ""
                                            }
                                          >
                                            <div className="counter">
                                              <span className="iconosE">
                                                {item.variable38 !== "15" &&
                                                  item.variable38 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable38
                                                      }
                                                      icon={item.variable38}
                                                    />
                                                  )}
                                                {item.variable38 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable38 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable38 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable38 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable80 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable80 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable63}
                                                  icon={item.variable63}
                                                />
                                              </span>
                                            </div>

                                            {item.variable32}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {this.state.diaConsulta === 1 && (
                                  <div className="XdiasSDC2t col-1">
                                    <div className="salto"></div>
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable8 === "4" &&
                                      item.variable62 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable14}
                                            name={item.variable14}
                                            data-fechaActual={item.variable20}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>
                                              -Seleccione Estatus-
                                            </option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable8 === "12" &&
                                      item.variable62 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable14}
                                            name={item.variable14}
                                            data-fechaActual={item.variable20}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>
                                              -Seleccione Estatus-
                                            </option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {item.variable62 === "camera" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable14}
                                          name={item.variable14}
                                          data-fechaActual={item.variable20}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="17" selected>
                                            Atendido
                                          </option>
                                          <option value="18">
                                            No Atendido
                                          </option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable62 === "camera-off" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable14}
                                          name={item.variable14}
                                          data-fechaActual={item.variable20}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="18" selected>
                                            No Atendido
                                          </option>
                                          <option value="17">Atendido</option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable8 === "4" ||
                                    item.variable8 === "12" ? (
                                      <div className="btn-group1" role="group">
                                        <button
                                          className="botoneraf1"
                                          onClick={this.cerrarLista.bind(
                                            this,
                                            item.variable14
                                          )}
                                        >
                                          Mensaje
                                        </button>
                                        <button
                                          className="botoneraf2"
                                          onClick={this.crearInf.bind(this)}
                                        >
                                          Informe
                                        </button>
                                        <button
                                          className="botoneraf3"
                                          onClick={this.cerrarLista2.bind(
                                            this,
                                            item.variable14,
                                            item.variable20
                                          )}
                                        >
                                          Reporte
                                        </button>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )}
                                {this.state.diaConsulta === 2 && (
                                  <div
                                    className="XdiasSDC2"
                                    onClick={
                                      item.variable9 === "4"
                                        ? this.consultarPaciente2.bind(
                                            this,
                                            item.variable1,
                                            item.variable3,
                                            this.state.dia2,
                                            item.variable15,
                                            "0",
                                            item.variable21
                                          )
                                        : item.variable9 !== "0"
                                        ? this.noCumplioEstatus.bind(this)
                                        : ""
                                    }
                                  >
                                    {item.variable9 !== "0" && (
                                      <div
                                        className="counter2"
                                        onClick={
                                          item.variable9 === "4"
                                            ? this.consultarPaciente.bind(
                                                this,
                                                item.variable1,
                                                item.variable3,
                                                this.state.dia2,
                                                item.variable15,
                                                item.variable9,
                                                item.variable21
                                              )
                                            : ""
                                        }
                                      >
                                        <div
                                          className={
                                            item.variable9 !== "4"
                                            ? "dato1"
                                            : "datox1"
                                          }
                                        >
                                          <div className="counter">
                                            {item.variable3 !== "" ? (
                                              <span className="iconosE">
                                                {item.variable27 !== "15" &&
                                                  item.variable27 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable27
                                                      }
                                                      icon={item.variable27}
                                                    />
                                                  )}
                                                {item.variable27 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable27 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable27 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable27 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable75 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable75 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable64}
                                                  icon={item.variable64}
                                                />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {item.variable3}
                                        </div>
                                        {item.variable33 !== "" ? (
                                          <div
                                            className={
                                              item.variable33 !== ""
                                                ? "dato2"
                                                : ""
                                            }
                                          >
                                            <div className="counter">
                                              <span className="iconosE">
                                                {item.variable39 !== "15" &&
                                                  item.variable39 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable39
                                                      }
                                                      icon={item.variable39}
                                                    />
                                                  )}
                                                {item.variable39 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable39 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable39 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable39 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable81 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable81 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable65}
                                                  icon={item.variable65}
                                                />
                                              </span>
                                            </div>

                                            {item.variable33}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {this.state.diaConsulta === 2 && (
                                  <div className="XdiasSDC2t col-1">
                                    <div className="salto"></div>
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable9 === "4" &&
                                      item.variable64 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable15}
                                            name={item.variable15}
                                            data-fechaActual={item.variable21}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>
                                              -Seleccione Estatus-
                                            </option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable9 === "12" &&
                                      item.variable64 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable15}
                                            name={item.variable15}
                                            data-fechaActual={item.variable21}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>
                                              -Seleccione Estatus-
                                            </option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {item.variable64 === "camera" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable15}
                                          name={item.variable15}
                                          data-fechaActual={item.variable21}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="17" selected>
                                            Atendido
                                          </option>
                                          <option value="18">
                                            No Atendido
                                          </option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable64 === "camera-off" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable15}
                                          name={item.variable15}
                                          data-fechaActual={item.variable21}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="18" selected>
                                            No Atendido
                                          </option>
                                          <option value="17">Atendido</option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable9 === "4" ||
                                    item.variable9 === "12" ? (
                                      <div className="btn-group1" role="group">
                                        <button
                                          className="botoneraf1"
                                          onClick={this.cerrarLista.bind(
                                            this,
                                            item.variable15
                                          )}
                                        >
                                          Mensaje
                                        </button>
                                        <button
                                          className="botoneraf2"
                                          onClick={this.crearInf.bind(this)}
                                        >
                                          Informe
                                        </button>
                                        <button
                                          className="botoneraf3"
                                          onClick={this.cerrarLista2.bind(
                                            this,
                                            item.variable15,
                                            item.variable21
                                          )}
                                        >
                                          Reporte
                                        </button>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )}
                                {this.state.diaConsulta === 3 && (
                                  <div
                                    className="XdiasSDC2"
                                    onClick={
                                      item.variable10 === "4"
                                        ? this.consultarPaciente2.bind(
                                            this,
                                            item.variable1,
                                            item.variable4,
                                            this.state.dia3,
                                            item.variable16,
                                            "0",
                                            item.variable22
                                          )
                                        : item.variable10 !== "0"
                                        ? this.noCumplioEstatus.bind(this)
                                        : ""
                                    }
                                  >
                                    {item.variable10 !== "0" && (
                                      <div
                                        className="counter2"
                                        onClick={
                                          item.variable10 === "4"
                                            ? this.consultarPaciente.bind(
                                                this,
                                                item.variable1,
                                                item.variable4,
                                                this.state.dia3,
                                                item.variable16,
                                                item.variable10,
                                                item.variable22
                                              )
                                            : ""
                                        }
                                      >
                                        <div
                                          className={
                                            item.variable10 !== "4"
                                            ? "dato1"
                                            : "datox1"
                                          }
                                        >
                                          <div className="counter">
                                            {item.variable4 !== "" ? (
                                              <span className="iconosE">
                                                {item.variable28 !== "15" &&
                                                  item.variable28 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable28
                                                      }
                                                      icon={item.variable28}
                                                    />
                                                  )}
                                                {item.variable28 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable28 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable28 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable28 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable76 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable76 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable66}
                                                  icon={item.variable66}
                                                />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {item.variable4}
                                        </div>
                                        {item.variable34 !== "" ? (
                                          <div
                                            className={
                                              item.variable34 !== ""
                                                ? "dato2"
                                                : ""
                                            }
                                          >
                                            <div className="counter">
                                              <span className="iconosE">
                                                {item.variable40 !== "15" &&
                                                  item.variable40 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable40
                                                      }
                                                      icon={item.variable40}
                                                    />
                                                  )}
                                                {item.variable40 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable40 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable40 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable40 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable82 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable82 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable67}
                                                  icon={item.variable67}
                                                />
                                              </span>
                                            </div>
                                            {item.variable34}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {this.state.diaConsulta === 3 && (
                                  <div className="XdiasSDC2t col-1">
                                    <div className="salto"></div>
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable10 === "4" &&
                                      item.variable66 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable16}
                                            name={item.variable16}
                                            data-fechaActual={item.variable22}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>
                                              -Seleccione Estatus-
                                            </option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable10 === "12" &&
                                      item.variable66 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable16}
                                            name={item.variable16}
                                            data-fechaActual={item.variable22}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>
                                              -Seleccione Estatus-
                                            </option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {item.variable66 === "camera" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable16}
                                          name={item.variable16}
                                          data-fechaActual={item.variable22}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="17" selected>
                                            Atendido
                                          </option>
                                          <option value="18">
                                            No Atendido
                                          </option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable66 === "camera-off" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable16}
                                          name={item.variable16}
                                          data-fechaActual={item.variable22}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="18" selected>
                                            No Atendido
                                          </option>
                                          <option value="17">Atendido</option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable10 === "4" ||
                                    item.variable10 === "12" ? (
                                      <div className="btn-group1" role="group">
                                        <button
                                          className="botoneraf1"
                                          onClick={this.cerrarLista.bind(
                                            this,
                                            item.variable16
                                          )}
                                        >
                                          Mensaje
                                        </button>
                                        <button
                                          className="botoneraf2"
                                          onClick={this.crearInf.bind(this)}
                                        >
                                          Informe
                                        </button>
                                        <button
                                          className="botoneraf3"
                                          onClick={this.cerrarLista2.bind(
                                            this,
                                            item.variable16,
                                            item.variable22
                                          )}
                                        >
                                          Reporte
                                        </button>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )}

                                {this.state.diaConsulta === 4 && (
                                  <div
                                    className="XdiasSDC2"
                                    onClick={
                                      item.variable11 === "4"
                                        ? this.consultarPaciente2.bind(
                                            this,
                                            item.variable1,
                                            item.variable5,
                                            this.state.dia4,
                                            item.variable17,
                                            "0",
                                            item.variable23
                                          )
                                        : item.variable11 !== "0"
                                        ? this.noCumplioEstatus.bind(this)
                                        : ""
                                    }
                                  >
                                    {item.variable11 !== "0" && (
                                      <div
                                        className="counter2"
                                        onClick={
                                          item.variable11 === "4"
                                            ? this.consultarPaciente.bind(
                                                this,
                                                item.variable1,
                                                item.variable5,
                                                this.state.dia4,
                                                item.variable17,
                                                item.variable11,
                                                item.variable23
                                              )
                                            : ""
                                        }
                                      >
                                        <div
                                          className={
                                            item.variable11 !== "4"
                                            ? "dato1"
                                            : "datox1"
                                          }
                                        >
                                          <div className="counter">
                                            {item.variable5 !== "" ? (
                                              <span className="iconosE">
                                                {item.variable29 !== "15" &&
                                                  item.variable29 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable29
                                                      }
                                                      icon={item.variable29}
                                                    />
                                                  )}
                                                {item.variable29 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}

                                                {item.variable29 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable29 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable29 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable77 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable77 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable68}
                                                  icon={item.variable68}
                                                />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {item.variable5}
                                        </div>
                                        {item.variable35 !== "" ? (
                                          <div
                                            className={
                                              item.variable35 !== ""
                                                ? "dato2"
                                                : ""
                                            }
                                            onClick={this.consultarPaciente.bind(
                                              this,
                                              item.variable1,
                                              item.variable35,
                                              this.state.dia4,
                                              item.variable47,
                                              item.variable53,
                                              item.variable59
                                            )}
                                          >
                                            <div className="counter">
                                              <span className="iconosE">
                                                {item.variable41 !== "15" &&
                                                  item.variable41 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable41
                                                      }
                                                      icon={item.variable41}
                                                    />
                                                  )}
                                                {item.variable41 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable41 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable41 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable41 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable83 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable83 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable69}
                                                  icon={item.variable69}
                                                />
                                              </span>
                                            </div>
                                            {item.variable35}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {this.state.diaConsulta === 4 && (
                                  <div className="XdiasSDC2t col-1">
                                    <div className="salto"></div>
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable11 === "4" &&
                                      item.variable68 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable17}
                                            name={item.variable17}
                                            data-fechaActual={item.variable23}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>-Estatus-</option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable11 === "12" &&
                                      item.variable68 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable17}
                                            name={item.variable17}
                                            data-fechaActual={item.variable23}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>-Estatus-</option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {item.variable68 === "camera" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable17}
                                          name={item.variable17}
                                          data-fechaActual={item.variable23}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="17" selected>
                                            Atendido
                                          </option>
                                          <option value="18">
                                            No Atendido
                                          </option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable68 === "camera-off" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable17}
                                          name={item.variable17}
                                          data-fechaActual={item.variable23}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="18" selected>
                                            No Atendido
                                          </option>
                                          <option value="17">Atendido</option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable11 === "4" ||
                                    item.variable11 === "12" ? (
                                      <div className="btn-group1" role="group">
                                        <button
                                          className="botoneraf1"
                                          onClick={this.cerrarLista.bind(
                                            this,
                                            item.variable17
                                          )}
                                        >
                                          Mensaje
                                        </button>
                                        <button
                                          className="botoneraf2"
                                          onClick={this.crearInf.bind(this)}
                                        >
                                          Informe
                                        </button>
                                        <button
                                          className="botoneraf3"
                                          onClick={this.cerrarLista2.bind(
                                            this,
                                            item.variable17,
                                            item.variable23
                                          )}
                                        >
                                          Reporte
                                        </button>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )}
                                {this.state.diaConsulta === 5 && (
                                  <div
                                    className="XdiasSDC2"
                                    onClick={
                                      item.variable12 === "4"
                                        ? this.consultarPaciente2.bind(
                                            this,
                                            item.variable1,
                                            item.variable6,
                                            this.state.dia5,
                                            item.variable18,
                                            "0",
                                            item.variable24
                                          )
                                        : item.variable12 !== "0"
                                        ? this.noCumplioEstatus.bind(this)
                                        : ""
                                    }
                                  >
                                    {item.variable12 !== "0" && (
                                      <div
                                        className="counter2"
                                        onClick={
                                          item.variable12 === "4"
                                            ? this.consultarPaciente.bind(
                                                this,
                                                item.variable1,
                                                item.variable6,
                                                this.state.dia5,
                                                item.variable18,
                                                item.variable12,
                                                item.variable24
                                              )
                                            : ""
                                        }
                                      >
                                        <div
                                          className={
                                            item.variable12 !== "4"
                                            ? "dato1"
                                            : "datox1"
                                          }
                                        >
                                          <div className="counter">
                                            {item.variable6 !== "" ? (
                                              <span className="iconosE">
                                                {item.variable30 !== "15" &&
                                                  item.variable30 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable30
                                                      }
                                                      icon={item.variable30}
                                                    />
                                                  )}
                                                {item.variable30 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable30 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable30 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable30 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable78 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable78 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable70}
                                                  icon={item.variable70}
                                                />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {item.variable6}
                                        </div>
                                        {item.variable36 !== "" ? (
                                          <div
                                            className={
                                              item.variable36 !== ""
                                                ? "dato2"
                                                : ""
                                            }
                                          >
                                            <div className="counter">
                                              <span className="iconosE">
                                                {item.variable42 !== "15" &&
                                                  item.variable42 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable42
                                                      }
                                                      icon={item.variable42}
                                                    />
                                                  )}
                                                {item.variable42 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable42 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable42 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable42 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable84 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable84 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable71}
                                                  icon={item.variable71}
                                                />
                                              </span>
                                            </div>
                                            {item.variable36}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {this.state.diaConsulta === 5 && (
                                  <div className="XdiasSDC2t col-1">
                                    <div className="salto"></div>
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable12 === "4" &&
                                      item.variable70 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable18}
                                            name={item.variable18}
                                            data-fechaActual={item.variable24}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>-Estatus-</option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable12 === "12" &&
                                      item.variable70 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable18}
                                            name={item.variable18}
                                            data-fechaActual={item.variable24}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>-Estatus-</option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {item.variable70 === "camera" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable18}
                                          name={item.variable18}
                                          data-fechaActual={item.variable24}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="17" selected>
                                            Atendido
                                          </option>
                                          <option value="18">
                                            No Atendido
                                          </option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable70 === "camera-off" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable18}
                                          name={item.variable18}
                                          data-fechaActual={item.variable24}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="18" selected>
                                            No Atendido
                                          </option>
                                          <option value="17">Atendido</option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable12 === "4" ||
                                    item.variable12 === "12" ? (
                                      <div className="btn-group1" role="group">
                                        <button
                                          className="botoneraf1"
                                          onClick={this.cerrarLista.bind(
                                            this,
                                            item.variable18
                                          )}
                                        >
                                          Mensaje
                                        </button>
                                        <button
                                          className="botoneraf2"
                                          onClick={this.crearInf.bind(this)}
                                        >
                                          Informe
                                        </button>
                                        <button
                                          className="botoneraf3"
                                          onClick={this.cerrarLista2.bind(
                                            this,
                                            item.variable18,
                                            item.variable24
                                          )}
                                        >
                                          Reporte
                                        </button>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )}

                                {this.state.diaConsulta === 6 && (
                                  <div
                                    className="XdiasSDC2"
                                    onClick={
                                      item.variable13 === "4"
                                        ? this.consultarPaciente2.bind(
                                            this,
                                            item.variable1,
                                            item.variable7,
                                            this.state.dia6,
                                            item.variable19,
                                            "0",
                                            item.variable25
                                          )
                                        : item.variable13 !== "0"
                                        ? this.noCumplioEstatus.bind(this)
                                        : ""
                                    }
                                  >
                                    {item.variable13 !== "0" && (
                                      <div
                                        className="counter2"
                                        onClick={
                                          item.variable13 === "4"
                                            ? this.consultarPaciente.bind(
                                                this,
                                                item.variable1,
                                                item.variable7,
                                                this.state.dia6,
                                                item.variable19,
                                                item.variable13,
                                                item.variable25
                                              )
                                            : ""
                                        }
                                      >
                                        <div
                                          className={
                                            item.variable13 !== "4"
                                            ? "dato1"
                                            : "datox1"
                                          }
                                        >
                                          <div className="counter">
                                            {item.variable7 !== "" ? (
                                              <span className="iconosE">
                                                {item.variable31 !== "15" &&
                                                  item.variable31 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable31
                                                      }
                                                      icon={item.variable31}
                                                    />
                                                  )}
                                                {item.variable31 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable31 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable31 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable31 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable79 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable79 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable72}
                                                  icon={item.variable72}
                                                />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {item.variable7}
                                        </div>
                                        {item.variable37 !== "" ? (
                                          <div
                                            className={
                                              item.variable37 !== ""
                                                ? "dato2"
                                                : ""
                                            }
                                          >
                                            <div className="counter">
                                              <span className="iconosE">
                                                {item.variable43 !== "15" &&
                                                  item.variable43 !== "16" && (
                                                    <FeatherIcon
                                                      id="camera-c"
                                                      className={
                                                        item.variable43
                                                      }
                                                      icon={item.variable43}
                                                    />
                                                  )}
                                                {item.variable43 === "15" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable43 === "15" && (
                                                  <FeatherIcon
                                                    className="noasistio"
                                                    icon="x-circle"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable43 === "16" && (
                                                  <FeatherIcon
                                                    className="dolar"
                                                    icon="dollar-sign"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable43 === "16" && (
                                                  <FeatherIcon
                                                    className="cancelado-2"
                                                    icon="x-square"
                                                    size="10px"
                                                  />
                                                )}
                                                {item.variable85 === "black" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-ok"
                                                    size="24px"
                                                  />
                                                )}
                                                {item.variable85 === "red" && (
                                                  <FeatherIcon
                                                    icon="mail"
                                                    className="mail-reporte-pendiente"
                                                    size="24px"
                                                  />
                                                )}
                                                <FeatherIcon
                                                  id="camera-c"
                                                  className={item.variable73}
                                                  icon={item.variable73}
                                                />
                                              </span>
                                            </div>
                                            {item.variable37}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {this.state.diaConsulta === 6 && (
                                  <div className="XdiasSDC2t col-1">
                                    <div className="salto"></div>
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable13 === "4" &&
                                      item.variable72 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable19}
                                            name={item.variable19}
                                            data-fechaActual={item.variable25}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>
                                              -Seleccione Estatus-
                                            </option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {this.state.fechaActual2 >=
                                      this.state.fechadeldia &&
                                      item.variable13 === "12" &&
                                      item.variable72 === "" && (
                                        <div className="XdiasSDC2h">
                                          <select
                                            id={item.variable19}
                                            name={item.variable19}
                                            data-fechaActual={item.variable25}
                                            data-name="numeroEstatus"
                                            value={this.state.numeroEstatus}
                                            onChange={this.onChange.bind(this)}
                                          >
                                            <option>
                                              -Seleccione Estatus-
                                            </option>
                                            <option value="17">Atendido</option>
                                            <option value="18">
                                              No Atendido
                                            </option>
                                          </select>
                                        </div>
                                      )}
                                    {item.variable72 === "camera" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable19}
                                          name={item.variable19}
                                          data-fechaActual={item.variable25}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="17" selected>
                                            Atendido
                                          </option>
                                          <option value="18">
                                            No Atendido
                                          </option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable72 === "camera-off" && (
                                      <div className="XdiasSDC2h">
                                        <select
                                          id={item.variable19}
                                          name={item.variable19}
                                          data-fechaActual={item.variable25}
                                          data-name="numeroEstatus"
                                          value={this.state.numeroEstatus}
                                          onChange={this.onChange.bind(this)}
                                        >
                                          <option value="18" selected>
                                            No Atendido
                                          </option>
                                          <option value="17">Atendido</option>
                                        </select>
                                      </div>
                                    )}
                                    {item.variable13 === "4" ||
                                    item.variable13 === "12" ? (
                                      <div className="btn-group1" role="group">
                                        <button
                                          className="botoneraf1"
                                          onClick={this.cerrarLista.bind(
                                            this,
                                            item.variable19
                                          )}
                                        >
                                          Mensaje
                                        </button>
                                        <button
                                          className="botoneraf2"
                                          onClick={this.crearInf.bind(this)}
                                        >
                                          Informe
                                        </button>
                                        <button
                                          className="botoneraf3"
                                          onClick={this.cerrarLista2.bind(
                                            this,
                                            item.variable19,
                                            item.variable25
                                          )}
                                        >
                                          Reporte
                                        </button>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    botonMen: state.botonMen,
  };
};

const mapDispatchToProps = {
  saveBotonMensaje,
};

export default connect(mapStateToProps, mapDispatchToProps)(CitasAction);

const LinkContainer = styled.div`
  a {
    position: relative;
    float: right;

    text-align: center;
    background: #fff;

    border-radius: 50%;
    width: 30px;
    height: 30px;
    text-decoration: none !important;
    color: inherit !important;
    font-size: 12px;
    padding-top: 5px;
    svg {
      width: 20px;
      height: 20px;
      stroke: #888 !important;
      transition: all 0.3s ease;
    }
    :hover svg {
      opacity: 0.8;
    }
  }
`;

const BadgeNotification = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #f00;
  border-radius: 50%;
  top: -2px;
  right: -1px;
`;

const Boton = styled.button`
  text-align: center;
  background: #fff;
  border-radius: 50%;
  border: none;
  width: 30px;
  height: 30px;
  text-decoration: none !important;
  color: inherit !important;
  font-size: 12px;
  padding-top: 5px;
`;
